<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Invite Staff Member</h4>
</div>
<div class="modal-body">
  <form [formGroup]="inviteForm">
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="inputCompanyOwner">Name</label>
          <input
            id="inputCompanyOwner"
            type="text"
            class="form-control"
            formControlName="name"
            placeholder="Awesome Coworker"
            [ngClass]="
              formUtil.displayFieldCss(
                inviteForm,
                'name',
                inviteFormSubmitAttempt
              )
            "
          />
          <div
            class="form-invalid-message"
            *ngIf="
              !inviteForm.get('name').valid &&
              inviteForm.get('name').dirty &&
              inviteFormSubmitAttempt
            "
          >
            Name cannot be empty
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label for="inputCompanyEmail">Email</label>
          <input
            id="inputCompanyEmail"
            type="text"
            class="form-control"
            formControlName="email"
            [ngClass]="
              formUtil.displayFieldCss(
                inviteForm,
                'email',
                inviteFormSubmitAttempt
              )
            "
            placeholder="awesome@ourfirm.com"
          />
          <div
            class="form-invalid-message"
            *ngIf="
              !inviteForm.get('email').valid &&
              inviteForm.get('email').dirty &&
              inviteFormSubmitAttempt
            "
          >
            Email must be valid
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label for="inputCompanyAccessLevel">Role (Access Level)</label>
          <select formControlName="access_level" class="form-control">
            <option value="1" selected>Admin</option>
            <option value="2">Staff</option>
          </select>
          <a
            href="https://clienthub.reamaze.com/kb/faqs/the-difference-between-a-practice-admin-practice-staff-and-client-user?_brand=clienthub"
            target="_blank" rel="noreferrer noopener"
            class="pt-1 d-block"
            >Understand how to choose a role</a
          >
        </div>
      </div>
    </div>
    <span><b>Note:</b> For this added user, your account will be billed the prorated per-user subscription fees for the remainder of this billing cycle (unless you are in a free trial).</span>
  </form>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-sm-6 text-left">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
        Cancel
      </button>
    </div>
    <div class="col-sm-6">
      <button
        type="button"
        [disabled]="!inviteForm.valid && inviteFormSubmitAttempt"
        class="btn btn-primary"
        (click)="inviteClient()"
      >
        <span>Invite</span>
      </button>
    </div>
  </div>
</div>
